const formValidation = [
  {
    fieldName: 'fundsRange',
    fieldNick: 'Rango de fondos',
    isValid: val => {
      return val ? (val !== undefined && typeof val === 'number' && val > 0) : false
    }
  }
]

const maxValue = 15000000
const minValue = 0

export {
  formValidation,
  maxValue,
  minValue
}
